import { createAction } from '@reduxjs/toolkit';
export const quickFetchHelpDeskViewMembersPending = createAction('filterResults/quickFetchHelpDeskViewMembersPending', requestArgs => {
  return {
    payload: {
      requestArgs
    }
  };
});
export const quickFetchHelpDeskViewMembersSucceeded = createAction('filterResults/quickFetchHelpDeskViewMembersSucceeded', (response, requestArgs) => {
  return {
    payload: {
      response,
      requestArgs
    }
  };
});
export const quickFetchHelpDeskViewMembersFailed = createAction('filterResults/quickFetchHelpDeskViewMembersFailed', requestArgs => {
  return {
    payload: {
      requestArgs
    }
  };
});